<template>
  <div class="dropdown camera-location-dropdown" style="float:left;">
    <button class="dropbtn attendance-dropdown camera-location-dropdown" v-if="locations">
      <input type="text" class="location-name-input" v-model="location.name" disabled>
      <i class="fas fa-caret-down btn-i-dropdown"></i>
    </button>
    <button class="dropbtn attendance-dropdown camera-location-dropdown" v-if="streamTypes">
      <input type="text" class="location-name-input" v-model="streamType" disabled>
      <i class="fas fa-caret-down btn-i-dropdown"></i>
    </button>
    <div class="dropdown-content dropdown-content-camera" v-if='locations'>
      <a href="#" v-for="(value, index) in locations" :key="index.id" @click.prevent="setLocation(value)">{{ value.name }}</a>
    </div>
    <div class="dropdown-content dropdown-content-camera" v-if='streamTypes'>
      <a href="#" @click.prevent="setStreamType(streamTypes)">{{ streamTypes}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CameraLocationFilter',
    props: {
      locations: {
        default: null
      },
      initialLocation: {},
      streamTypes: '',
    },
    data() {
      return {
        location: {
          name : '',
        },
        streamType: 'IP',
      };
    },
    watch: {
      initialLocation(newVal) {
        if(newVal) {
          this.location = newVal;
        } else {
          this.location = {};
        }
      }
    },
    methods: {
      setLocation(newVal) {
        this.location = newVal;
        this.$emit('locationSelected', newVal);
      },
      setStreamType(newVal) {
        this.streamType = newVal;
      }
    }
  }
</script>
